export const HEADER_HEIGHT_DESKTOP = 80;
export const ECARD_LANDING_LEFT_PANE_WIDTH_DESKTOP = '60%';
export const ECARD_LANDING_RIGHT_PANE_WIDTH_DESKTOP = '40%';
